import React, {createContext} from "react";
import RentDemand from "../../../../shared/entities/Demand";

const RentDemandContext = createContext<RentDemand>(new RentDemand());

export default RentDemandContext;